



















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import UiDropdownMenu from '@/components/semantic-ui/DropdownMenu'
import UiSelectionDropdown from '@/components/semantic-ui/SelectionDropdown.vue'

import { Brand, Category, PantryItem } from '@/datastore/models'

import grocery from '@/store/modules/grocery'

import PantryItemCard from './PantryItemCard.vue'

@Component({
	components: {
		PantryItemCard,
		UiDropdownMenu,
		UiSelectionDropdown,
	},
})
export default class PantryCategoryList extends Vue {

	@Prop({ required: true })
	readonly category!: Category

	@Prop()
	readonly expanded?: boolean

	@Prop()
	readonly filter?: string

	addedPantryItem = ''

	isAddingPantryItem = false

	ribbonColor = 'white'

	get items(): PantryItem[] {

		let items = (grocery.categoryPantryItems[this.category.$id] || [])
			.map(pantryItemId => grocery.pantryItemsCollection[pantryItemId])
			.filter<PantryItem>((i): i is PantryItem => !!i)

		if (this.filter) {
			const filter = this.filter.toLocaleLowerCase()
			if (!this.category.name.toLocaleLowerCase().includes(filter)) {
				items = items.filter(item => this.getPantryItemSearchIndex(item).some(i => i.includes(filter)))
			}
		}

		return items.sort((a, b) => a.name.localeCompare(b.name))
	}

	get pantryItems(): PantryItem[] {

		return grocery.pantryItems
	}

	mounted(): void {

		const el = this.$el.querySelector('.ui.ribbon.label')
		if (el) {
			this.ribbonColor = window.getComputedStyle(el).backgroundColor || 'white'
		}
	}

	getPantryItemBrands(pantryItemId: string): Brand[] {

		return (grocery.pantryItemBrands[pantryItemId] ?? [])
			.map(b => grocery.brandsCollection[b])
			.filter((b): b is Brand => !!b)
	}

	getPantryItemCategories(pantryItemId: string): Category[] {

		return grocery.pantryItemCategories[pantryItemId]
			.map(i => grocery.categoriesCollection[i])
			.sort((a, b) => a.name.localeCompare(b.name))
	}

	getPantryItemSearchIndex(pantryItem: PantryItem): string[] {

		return [
			pantryItem.name,
			...this.getPantryItemBrands(pantryItem.$id).map(b => b.name),
		].map(i => i.toLocaleLowerCase())
	}

	@Watch('addedPantryItem')
	async onWatchAddedPantryItem(): Promise<void> {

		this.isAddingPantryItem = true

		const { addedPantryItem } = this
		const { $id: categoryId } = this.category
		const pantryItem = grocery.pantryItemsCollection[addedPantryItem]
		const pantryItemId = (pantryItem)
			? pantryItem.$id
			: (await grocery.addPantryItem(addedPantryItem)).id
		await grocery.addPantryItemToCategory({ categoryId, pantryItemId })

		this.isAddingPantryItem = false
	}

}

